import { render } from "./DeleteCompanyModal.vue?vue&type=template&id=1e954343"
import script from "./DeleteCompanyModal.vue?vue&type=script&lang=js"
export * from "./DeleteCompanyModal.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__